import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import { ReactComponent as Logo } from "../assets/images/logos/logo-login.svg";

// Shown for any route that does not match and when GET /me/permissions answers
// 404. It borrows the login screen's dark canvas and centred card so a dead end
// still looks like part of the product rather than a browser error.
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={"login__wrapper not-found__wrapper"}>
        <div className={"login__logo"}>
          <Logo />
        </div>
        <div className={"not-found__card"}>
          <p className={"not-found__code"} aria-hidden={"true"}>
            404
          </p>
          <h5>This page could not be found</h5>
          <p className={"not-found__message"}>
            The page you are looking for may have been moved, renamed, or is no
            longer available.
          </p>
          <p className={"not-found__hint"}>
            If you followed a link inside TriloDocs to get here, please contact
            the TriloDocs Team.
          </p>
          <div className={"not-found__actions"}>
            <button
              type={"button"}
              onClick={() => navigate(-1)}
              className={"input-submit input-submit__secondary"}>
              Go back
            </button>
            <Link
              to={"/dashboard"}
              className={"input-submit input-submit__primary"}>
              Back to dashboard
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
